import { Box, Divider, Menu, MenuItem, Theme, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import SwapVertIcon from '@mui/icons-material/SwapVert';

interface SortDropdownProps {
  extendedPalette?: any;
  sortOrder: 'newest' | 'oldest';
  onSortChange: (value: 'newest' | 'oldest') => void;
}

export const SortDropdown = ({ extendedPalette, sortOrder, onSortChange }: SortDropdownProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const sortOptions = [
    { id: 'newest', name: 'Newest to Oldest' },
    { id: 'oldest', name: 'Oldest to Newest' },
  ];

  const handleMenuItemClick = (option: typeof sortOptions[0]) => {
    onSortChange(option.id as 'newest' | 'oldest');
    setAnchorEl(null);
  };

  return (
    <div>
      <Box
        onClick={handleClickMenu}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.2rem',
          background: !isMobile ? (extendedPalette?.hasCustomTheme ? extendedPalette.buttonbackgroundIcon : '#212d6d') : 'transparent',
          padding: '8px',
          width: !isMobile ? 120 : 70,
          height: 40,
          borderRadius: '24px',
          justifyContent: 'center',
          '&:hover': {
            backgroundColor: `${extendedPalette?.hasCustomTheme ? extendedPalette.buttonbackgroundIcon : '#0072CE'} !important`,
          },
        }}>
        <SwapVertIcon sx={{ fontSize: 14, color: 'white' }} />
        <Box
          component="span"
          sx={{
            fontSize: '0.875rem',
            color: 'white',
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
            lineHeight: 1,
          }}>
          Sort
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#D8E8F6',
            borderRadius: '12px',
            width: '180px',
            padding: '8px',
            top: '1rem',
            left: {
              xs: '0',
              sm: '0',
              md: '0',
              lg: '72% !important',
              xl: '0%',
            },
          },
        }}>
        {sortOptions.map((option, index) => (
          <div key={option.id}>
            <MenuItem
              onClick={() => handleMenuItemClick(option)}
              sx={{
                justifyContent: 'space-between',
                fontSize: '16px',
                backgroundColor: sortOrder === option.id ? '#0072CE' : 'transparent',
                color: sortOrder === option.id ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: '#0072CE',
                  color: '#fff',
                },
              }}>
              {option.name}
            </MenuItem>
            {index !== sortOptions.length - 1 && <Divider />}
            {index < sortOptions.length && <hr style={{ backgroundColor: '#C6D7E7', border: 'none', margin: '0' }} />}
          </div>
        ))}
      </Menu>
    </div>
  );
};
